export const grid_settings = {
  showSideBar: false,
  showRowGroupPanel: "always",
  sideBar: "columns",
  defaultColDefs: {
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    resizable: true,
    sortable: true,
    filter: true
  },
  customIcons: {
    columnRemoveFromGroup: '<i class="fa fa-times"/>',
    filter: '<i class="fa fa-filter"/>',
    sortAscending: '<i class="fa fa-long-arrow-alt-down"/>',
    sortDescending: '<i class="fa fa-long-arrow-alt-up"/>',
    groupExpanded: '<i class="far fa-minus-square"/>',
    groupContracted: '<i class="far fa-plus-square"/>'
  },
  deText: {
    filterPlaceholder: "in allen Spalten suchen nach ..."
  },
  filterPlaceholder: "search in all columns ...",
  deLocaleText: {
    page: "Seite",
    more: "mehr",
    to: "vom ",
    of: "bis",
    next: "nächster",
    last: "letzter",
    first: "erster",
    previous: "vorheriger",
    loadingOoo: "Lädt...",
    selectAll: "Alles auswählen",
    searchOoo: "Suche...",
    blanks: "Leer",
    filterOoo: "Filter...",
    applyFilter: "Filter anwenden...",
    equals: "gleich",
    notEqual: "ungleich",
    lessThan: "kleiner als",
    greaterThan: "größer als",
    lessThanOrEqual: "kleiner oder gleich",
    greaterThanOrEqual: "größer oder gleich",
    inRange: "im Bereich",
    contains: "enthält",
    notContains: "enthält nicht",
    startsWith: "beginnt mit",
    endsWith: "endet mit",
    andCondition: "AND",
    orCondition: "OR",
    group: "Gruppe",
    columns: "Spalten",
    filters: "Filter",
    rowGroupColumns: "Pivot Spalten",
    rowGroupColumnsEmptyMessage: "Spalten zum Gruppieren hierhin ziehen",
    valueColumns: "Spaltenwerte",
    pivotMode: "Pivot-Mode",
    groups: "Gruppen",
    values: "Werte",
    pivots: "Pivots",
    valueColumnsEmptyMessage: "Spalten zum Aggregieren hierhin ziehen",
    pivotColumnsEmptyMessage: "Spalten Für Pivotierung hierhin ziehen",
    toolPanelButton: "Werkzeug Bereich",
    noRowsToShow: "keine Daten",
    pinColumn: "Spalte anheften",
    valueAggregation: "Wert Agg",
    autosizeThiscolumn: "diese Spaltengröße anpassen",
    autosizeAllColumns: "alle Spaltengrößen anpassen",
    groupBy: "Gruppieren nach",
    ungroupBy: "Zurücksetzen Gruppierung nach",
    resetColumns: "Spalten zurücksetzen",
    expandAll: "Alles aufklappen",
    collapseAll: "Alles zuklappen",
    toolPanel: "Werkzeug Bereich",
    export: "Export",
    csvExport: "CSV Export",
    excelExport: "Excel Export (.xlsx)",
    excelXmlExport: "Excel Export (.xml)",
    pivotChartAndPivotMode: "Pivot Chart & Pivot Mode",
    pivotChart: "Pivot Chart",
    chartRange: "Chart Range",
    columnChart: "Spalte",
    groupedColumn: "Grouped",
    stackedColumn: "Stacked",
    normalizedColumn: "100% Stacked",
    barChart: "Bar",
    groupedBar: "Grouped",
    stackedBar: "Stacked",
    normalizedBar: "100% Stacked",
    pieChart: "Pie",
    pie: "Pie",
    doughnut: "Doughnut",
    line: "Line",
    xyChart: "X Y (Scatter)",
    scatter: "Scatter",
    bubble: "Bubble",
    areaChart: "Area",
    area: "Area",
    stackedArea: "Stacked",
    normalizedArea: "100% Stacked",
    pinLeft: "links",
    pinRight: "rechts",
    noPin: "nicht aufheben",
    sum: "Summe",
    min: "Min",
    max: "Max",
    none: "None",
    count: "Count",
    average: "Durchschnitt",
    filteredRows: "Filtered",
    selectedRows: "Selected",
    totalRows: "Total Rows",
    totalAndFilteredRows: "Rows",
    copy: "Kopieren",
    copyWithHeaders: "Kopieren mit Überschriften",
    ctrlC: "STRG + C",
    paste: "Einfügen",
    ctrlV: "STRG + V",
    pivotChartTitle: "Pivot Chart",
    rangeChartTitle: "Range Chart",
    settings: "Einstellungen",
    data: "Daten",
    format: "Format",
    categories: "Kategorien",
    series: "Series",
    axis: "Achse",
    color: "Farbe",
    thickness: "Dicke",
    xRotation: "X Rotation",
    yRotation: "Y Rotation",
    ticks: "Ticks",
    width: "Weite",
    length: "Länge",
    padding: "Padding",
    chart: "Graphik",
    title: "Titel",
    font: "Font",
    top: "Oben",
    right: "Rechts",
    bottom: "Untern",
    left: "Links",
    labels: "Labels",
    size: "Größe",
    legend: "Legende",
    position: "Position",
    markerSize: "Marker Größe",
    markerStroke: "Marker Stroke",
    markerPadding: "Marker Padding",
    itemPaddingX: "Item Padding X",
    itemPaddingY: "Item Padding Y",
    strokeWidth: "Stroke Width",
    offset: "Offset",
    tooltips: "Tooltips",
    offsets: "Offsets",
    callout: "Callout",
    markers: "Markers",
    shadow: "Shadow",
    blur: "Blur",
    xOffset: "X Offset",
    yOffset: "Y Offset",
    lineWidth: "Line Width",
    normal: "Normal",
    bold: "Fett",
    italic: "Kursiv",
    boldItalic: "Fett Kursiv",
    fillOpacity: "Fill Opacity",
    strokeOpacity: "Line Opacity",
    columnGroup: "Spalte",
    barGroup: "Bar",
    pieGroup: "Pie",
    lineGroup: "Linie",
    scatterGroup: "Scatter",
    areaGroup: "Area",
    groupedColumnTooltip: "Grouped",
    stackedColumnTooltip: "Stacked",
    normalizedColumnTooltip: "100% Stacked",
    groupedBarTooltip: "Grouped",
    stackedBarTooltip: "Stacked",
    normalizedBarTooltip: "100% Stacked",
    pieTooltip: "Pie",
    doughnutTooltip: "Doughnut",
    lineTooltip: "Line",
    groupedAreaTooltip: "Grouped",
    stackedAreaTooltip: "Stacked",
    normalizedAreaTooltip: "100% Stacked",
    scatterTooltip: "Scatter",
    bubbleTooltip: "Bubble",
    noDataToChart: "No data available to be charted.",
    pivotChartRequiresPivotMode: "Pivot Chart requires Pivot Mode enabled."
  }
};

export default {
  grid_settings
};
